export default __webpack_public_path__ + "static/media/puffer_tetra.1b2724d4.jpg";